export const generateId = (prefix) => {
    const arr = new Uint8Array(6);
    crypto.getRandomValues(arr);
    const random = Array.from(arr, b => b.toString(36)).join('').substring(0, 9);
    return prefix + '_' + random;
};

export const extractVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
        return match[2];
    }
    const shortsRegExp = /^.*youtube\.com\/shorts\/([^#&?]*).*/;
    const shortsMatch = url.match(shortsRegExp);
    if (shortsMatch && shortsMatch[1].length === 11) {
        return shortsMatch[1];
    }
    return null;
};

export const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};
